/**
 * Turning download links into actual downloads.
 *
 * The API hands back presigned S3 URLs rather than file bytes, so the browser
 * fetches straight from S3 and the API never streams hundreds of megabytes.
 * Each link already carries a Content-Disposition naming the user's own file,
 * so an anchor click is all that is needed.
 */

/**
 * Browsers rate-limit and sometimes silently drop a burst of simultaneous
 * downloads. Spacing them out is the difference between "10 files downloaded"
 * and "3 files downloaded and no error anywhere".
 */
const STAGGER_MS = 350;

const clickDownload = (url) => {
  const a = document.createElement("a");
  a.href = url;
  // The link is cross-origin (S3), so `download` is advisory only - the
  // Content-Disposition on the signed URL is what actually names the file.
  //
  // `target=_blank` is not cosmetic: a normal attachment response never
  // navigates, but an expired or otherwise failed link returns an S3 error
  // page, and without this the user's tab leaves the app to display it.
  a.target = "_blank";
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const startDownload = (download) => clickDownload(download.url);

export const startDownloads = (downloads) =>
  downloads.forEach((download, index) => {
    setTimeout(() => clickDownload(download.url), index * STAGGER_MS);
  });
